import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import { toast } from 'react-toastify'
import Ribbon from '../../../../../core/common/ribbon/ribbon'
import { useCompareOpportunitiesMutation, useGetOpportunityDetailsbyIdQuery, useUpsertOpportunityDetailsMutation } from '../../../../../services/EndPointsApis'
import DescriptionTab from './DescriptionTab'
import SituationTab from './SituationTab'
import ScopeTab from './ScopeTab'
import PdmCheckInTab from './PdmCheckInTab'
import ArchitecturalReviewTab from './ArchitecturalReviewTab'
import { initialValuesOpportunities } from './InitialValuesOpportunities'


const OpportunityDetailsWizard = ({ projectId, opportunityDetailsData, storeProjectId, showRibbon, setOpportunityData, setOpportunityInitialValues, formikOpportunities }: any) => {
    // const { projectId } = useParams();

    const { data: opportunityByIdData, refetch } = useGetOpportunityDetailsbyIdQuery({ id: projectId || storeProjectId });


    const [updateId, setUpdateId] = useState(0);

    useEffect(() => {
        if (opportunityByIdData?.result && Object.keys(opportunityByIdData?.result).length > 0) {
            setUpdateId(opportunityByIdData?.result?.id);
            formikOpportunities.setValues({ ...opportunityByIdData?.result });
        } else {
            setUpdateId(0);
        }
    }, [opportunityByIdData]);

    useEffect(() => {
        if (setOpportunityData) {
            setOpportunityInitialValues(initialValuesOpportunities)
            setOpportunityData(formikOpportunities)
        }
    }, [setOpportunityData, formikOpportunities.values])

    useEffect(() => {
        if (opportunityDetailsData) {
            formikOpportunities.setValues({ ...opportunityDetailsData })
        }
    }, [opportunityDetailsData])

    useEffect(() => {
        refetch()
    }, [])

    return (
        <div className='row' >
            <div className='col-md-12'>
                <Tab.Container id="left-tabs-example" defaultActiveKey="description">
                    <Row>
                        <Col sm={12}>
                            <div className='card'>
                                <div className='card-body p-2 card-css'>
                                    <div className='d-flex laign-items-center'>
                                        <Nav>
                                            <Nav.Item>
                                                <Nav.Link eventKey="description">Description</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="situation">Situation</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="scope">Scope</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="PDMCheck-In">PDM Check-In</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="architecturalReview">Architectural Review</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col sm={12} style={{ height: '599px', overflow: 'auto' }}>
                            <form onSubmit={formikOpportunities.handleSubmit}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="description"><DescriptionTab formik={formikOpportunities} opportunityByIdData={opportunityByIdData} /></Tab.Pane>
                                    {/* <Tab.Pane eventKey="propertyAddress"><PropertyAddress /></Tab.Pane> */}
                                    <Tab.Pane eventKey="situation"><SituationTab formik={formikOpportunities} opportunityByIdData={opportunityByIdData} /></Tab.Pane>
                                    <Tab.Pane eventKey="scope"><ScopeTab formik={formikOpportunities} opportunityByIdData={opportunityByIdData} /></Tab.Pane>
                                    {/* <Tab.Pane eventKey="appointmentDetails"><AppointmentsTab /></Tab.Pane> */}
                                    <Tab.Pane eventKey="PDMCheck-In"><PdmCheckInTab formik={formikOpportunities} opportunityByIdData={opportunityByIdData} /></Tab.Pane>
                                    <Tab.Pane eventKey="architecturalReview"><ArchitecturalReviewTab formik={formikOpportunities} opportunityByIdData={opportunityByIdData} /></Tab.Pane>
                                    <Tab.Pane eventKey="miscellaneous">
                                        <div className="card">
                                            <div className="card-body">
                                                <center>
                                                    <h3 className='text-muted'>It looks like there's no data available</h3>
                                                </center>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </form>
                        </Col>
                    </Row>
                </Tab.Container>

            </div>
        </div>
    )
}

export default OpportunityDetailsWizard